import fullLogo from "@/assets/full-logo.png";
import studioSignature from "@/assets/signeture.jpeg";
import { config } from "@/shared/lib/config";
import { formatDate, formatDateTime } from "@/shared/lib/date-time";
import { escapeHtmlForPrintUnsafeContext } from "@/shared/lib/form-responses-print-a4";
import {
  loadNotoSansLaoPrintFontFaceCss,
  PRINT_DOCUMENT_FONT_FAMILY,
} from "@/shared/lib/print-fonts";
import QRCode from "qrcode";

export type PrintStudentMembershipConfirmationParams = {
  memberId: string;
  name: string;
  phoneNumber?: string | null;
  email?: string | null;
  dateOfBirth?: string | null;
  gender?: "male" | "female" | "other" | null;
  groupName?: string | null;
  registeredAt: string;
  status: "active" | "deactivated";
};

const GENDER_LABELS: Record<"male" | "female" | "other", string> = {
  male: "ຊາຍ",
  female: "ຍິງ",
  other: "ອື່ນໆ",
};

const MEMBERSHIP_TERMS_TITLE = "ເງື່ອນໄຂ ແລະ ກົດລະບຽບໃນການເຂົ້າຮ່ວມ";

const MEMBERSHIP_TERMS_ITEMS: string[] = [
  "ຕ້ອງລົງທະບຽນ ແລະ ຊໍາລະຄ່າຮຽນກ່ອນເຂົ້າຮຽນທຸກຄັ້ງ (ສໍາລັບນັກຮຽນໃຫມ່): HIPHOP, Choreography, Breaking Class, Private",
  "ໃນກໍລະນີຊໍາລະຄ່າຮຽນຊ້າເກີນ 2 ເດືອນ ທາງສະຕູດິໂອຈະມີການປັບໄຫມ 10% ຂອງມູນຄ່າຮຽນ",
  "ຫ້າມນັກຮຽນເຂົ້າຮຽນຊ້າ ເກີນ 20 ນາທີ ຫ້າມຂາດຮຽນເກີນ 4 ຊົ່ວໂມງ ຈະຖືກຕັດສິດອອກຈາກລະບົບ ແລະ ຈະໄດ້ລົງທະບຽນຮຽນຄືນໃຫມ່ ໃນກໍລະນີມີເຫດສຸກເສີນຈໍາເປັນຕ້ອງແຈ້ງທາງສະຕູດິໂອກ່ອນຮຽນ 1 ມື້ (ຍົກເວັ້ນ ກໍລະນີຈໍາເປັນເຊັ່ນ: ອຸບັດເຫດ, ບໍ່ສະບາຍ)",
  "ໃນກໍລະນີນັກຮຽນມີໂລກປະຈໍາໂຕ ຫອບຫືດ, ໂລກຫົວໃຈ, ເລືອດຈາງ ອື່ນໆທີ່ສົ່ງຜົນກະທົບຕໍ່ການອອກກໍາລັງກາຍແມ່ນໃຫ້ແຈ້ງທາງສະຕູດິໂອກ່ອນເຂົ້າຮຽນເພື່ອໃຫ້ທາງສະຕູດິໂອໄດ້ພິຈາລະນາຄືນໃຫມ່ໃນການເຂົ້າຮຽນ (ຫາກກໍລະນີມີການປິດບັງຂໍ້ມູນດັ່ງກ່າວ ຖ້າຫາກເກີດເຫດສຸກເສີນຕໍ່ນັກຮຽນທາງສະຕູດິໂອຈະບໍ່ມີການຮັບຜິດຊອບໃດໆ)",
  "ຫ້າມໃຊ້ຄວາມຮຸນແຮງ, ຄໍາເວົ້າທີ່ບໍ່ສຸພາບ ແລະ ພຶດຕິກໍາທີ່ບໍ່ເຫມາະສົມໃນສະຕູດິໂອຢ່າງເດັດຂາດ ຖ້າຫາກພົບເຫັນຈະມີການສໍາຫຼວດ. ໃນກໍລະນີຮ້າຍແຮງຈົນເຖິງຂັ້ນເລືອດ ຕົກຢາງອອກຈະຖືກໃສ່ໂທດຕາມກົດລະບຽບການໃຊ້ຄວາມຮຸນແຮງ ກໍໃຫ້ເກີດຄວາມເສຍຫາຍຕໍ່ຊັບສິນ ແລະ ຊື່ສຽງຂອງສະຕູດິໂອຈະຖືກໄລ່ອອກໂດຍບໍມີຂໍ້ຍົກເວັ້ນ",
  "ຫ້າມນໍາອາຫານເຂົ້າມາກິນໃນຫ້ອງຮຽນເດັດຂາດ (ສໍາລັບນ້ໍາດື່ມຫຼັງຈາກດື່ມແລ້ວໃຫ້ເກັບມຽນເປັນທີ່ຮຽບຮ້ອຍ ແລະ ຖິ້ມຂີ້ເຫຍື້ອໃນບໍລິເວນທີ່ທາງເຮົາໄດ້ກໍານົດໄວ້ໃຫ້)",
  "ຫ້າມໃຫ້ພໍ່ແມ່ຜູ້ປົກຄອງຫຼືບຸກຄົນທີ່ບໍ່ໄດ້ຮັບອະນຸຍາດເຂົ້າມາຢູ່ໃນຫ້ອງຮຽນໃນຊົ່ວໂມງຮຽນຫຼືຝຶກຊ້ອມ ເດັດຂາດ (ທາງເຮົາໄດ້ຈັດກຽມສະຖານທີ່ ແລະ ຕັ່ງນັ່ງໃຫ້ສໍາລັບພໍ່ແມ່ຜູ້ປົກຄອງທີ່ຕ້ອງການລໍຖ້າລູກຫຼານຂອງທ່ານໃນເວລາຮຽນ)",
  "ກະລຸນາກວດສອບຊັບສິນ, ເຄື່ອງຂອງມີຄ່າທຸກຊະນິດກ່ອນອອກຈາກຫ້ອງຮຽນທຸກໆຄັ້ງ (ຖ້າຫາກເກີດຄວາມເສຍຫາຍຕໍ່ຊັບສິນທາງສະຕູດິໂອຈະບໍ່ມີການຮັບຜິດຊອບ)",
  "ຫ້າມຫຼິ້ນໂທລະສັບ, ຢອກກັນ ຫຼື ສົ່ງສຽງດັງລົບກວນຄົນອື່ນໃນເວລາຮຽນ (ໂທລະສັບຄວນປິດສຽງທຸກຄັ້ງ)",
];

const MEMBERSHIP_TERMS_FOOTER =
  "ຫາກບັນດານັກຮຽນບຸກຄົນໃດລະເມີດບໍ່ປະຕິບັດຕາມກົດລະບຽບທີ່ທາງສະຕູດິໂອໄດ້ວາງອອກ ຈະມີການຕັກເຕືອນ ແລະ ລົງໂທດຕາມທີ່ເຫັນສົມຄວນ.";

const SIGNATURE_DATE_PLACEHOLDER = "..../..../....";

export const STUDENT_MEMBERSHIP_CONFIRMATION_PRINT_STYLES_A4 = `
  @media print {
    @page {
      size: A4 portrait;
      margin: 10mm;
    }
    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .smc-actions {
      display: none !important;
    }
    .smc-page {
      box-shadow: none !important;
      margin: 0 !important;
      min-height: auto !important;
      width: auto !important;
      padding: 0 !important;
      background: #fff !important;
    }
    .smc-member-id-box,
    .smc-profile {
      background: #fff !important;
    }
  }

  * { box-sizing: border-box; }
  body {
    margin: 0;
    padding: 16px;
    font-family: ${PRINT_DOCUMENT_FONT_FAMILY};
    font-size: 15px;
    line-height: 1.5;
    color: #0a0a0a;
    background: #f4f4f5;
  }

  .smc-actions {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-bottom: 12px;
  }
  .smc-actions button {
    border: 1px solid #d4d4d8;
    border-radius: 6px;
    background: #fff;
    padding: 8px 14px;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
  }
  .smc-actions button.primary {
    border-color: #dc2626;
    background: #dc2626;
    color: #fff;
  }

  .smc-page {
    width: 210mm;
    margin: 0 auto;
    padding: 10mm 12mm;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .smc-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 4px;
  }
  .smc-brand-block {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    line-height: 0;
  }
  .smc-logo {
    display: block;
    height: 80px;
    width: auto;
    max-width: 280px;
    object-fit: contain;
    object-position: left center;
  }
  .smc-doc-meta {
    text-align: right;
    font-size: 13px;
    color: #404040;
    line-height: 1.45;
  }
  .smc-doc-meta p {
    margin: 0 0 2px;
  }
  .smc-doc-meta p:last-child {
    margin-bottom: 0;
  }

  .smc-title {
    margin: 10px 0 2px;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 0.02em;
  }
  .smc-subtitle {
    margin: 0 0 10px;
    font-size: 13px;
    color: #525252;
  }

  .smc-top-row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: stretch;
    margin-bottom: 10px;
  }

  .smc-member-id-box {
    margin-bottom: 0;
    padding: 10px 12px;
    border: 1px solid #e5e5e5;
    border-left: 4px solid #dc2626;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .smc-member-id-label {
    font-size: 13px;
    font-weight: 600;
    color: #525252;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin: 0 0 4px;
  }
  .smc-member-id-value {
    margin: 0;
    font-size: 36px;
    font-weight: 800;
    letter-spacing: 0.08em;
    color: #0a0a0a;
  }

  .smc-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px 16px;
    margin-bottom: 10px;
  }
  .smc-field-label {
    font-size: 12px;
    font-weight: 600;
    color: #737373;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 2px;
  }
  .smc-field-value {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #171717;
    word-break: break-word;
  }

  .smc-profile {
    margin-top: 0;
    padding: 8px 10px;
    border: 1px dashed #a3a3a3;
    text-align: center;
    background: #fafafa;
    min-width: 112px;
  }
  .smc-profile-title {
    margin: 0 0 4px;
    font-size: 14px;
    font-weight: 700;
    color: #171717;
    line-height: 1.3;
  }
  .smc-profile-qr {
    display: block;
    width: 88px;
    height: 88px;
    margin: 0 auto;
    object-fit: contain;
  }

  .smc-terms {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e5e5e5;
  }
  .smc-terms-title {
    margin: 0 0 6px;
    font-size: 15px;
    font-weight: 700;
    color: #171717;
  }
  .smc-terms-list {
    margin: 0;
    padding-left: 16px;
    font-size: 12px;
    line-height: 1.4;
    color: #262626;
  }
  .smc-terms-list li {
    margin: 0 0 4px;
    padding-left: 2px;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .smc-terms-list li:last-child {
    margin-bottom: 0;
  }
  .smc-terms-footer {
    margin: 6px 0 0;
    font-size: 12px;
    line-height: 1.4;
    color: #404040;
  }

  .smc-signatures {
    margin-top: 10px;
    padding-top: 0;
  }
  .smc-signatures-title {
    margin: 0 0 4px;
    font-size: 15px;
    font-weight: 700;
    color: #171717;
  }
  .smc-signatures-intro {
    margin: 0 0 12px;
    font-size: 12px;
    line-height: 1.4;
    color: #404040;
  }
  .smc-signatures-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 40px;
  }
  .smc-signature-block {
    padding: 0;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .smc-signature-party {
    margin: 0 0 12px;
    padding-bottom: 0;
    font-size: 13px;
    font-weight: 700;
    color: #171717;
    text-decoration: underline;
  }
  .smc-signature-row {
    margin-bottom: 14px;
  }
  .smc-signature-row:last-child {
    margin-bottom: 0;
  }
  .smc-signature-row--date {
    margin-bottom: 0;
  }
  .smc-signature-date-line {
    margin: 0;
    display: flex;
    align-items: baseline;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #171717;
  }
  .smc-signature-date-line .smc-signature-label {
    margin: 0;
    flex-shrink: 0;
  }
  .smc-signature-date-placeholder {
    letter-spacing: 0.04em;
  }
  .smc-signature-label {
    margin: 0 0 6px;
    font-size: 12px;
    font-weight: 600;
    color: #737373;
    letter-spacing: 0.03em;
  }
  .smc-signature-value {
    margin: 0;
    min-height: 28px;
    padding-bottom: 0;
    font-size: 14px;
    font-weight: 600;
    color: #171717;
    word-break: break-word;
  }
  .smc-signature-value--blank {
    min-height: 36px;
  }
  .smc-signature-value--sign {
    min-height: 52px;
  }
  .smc-signature-row--studio-sign {
    margin-bottom: 0;
  }
  .smc-studio-signature-img {
    display: block;
    max-height: 192px;
    max-width: 100%;
    width: auto;
    object-fit: contain;
  }
`;

async function loadImageDataUrl(src: string): Promise<string | undefined> {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(undefined);
        return;
      }
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => resolve(undefined);
    img.src = src;
  });
}

async function loadLogoDataUrl(): Promise<string | undefined> {
  return loadImageDataUrl(fullLogo);
}

async function loadStudioSignatureDataUrl(): Promise<string | undefined> {
  return loadImageDataUrl(studioSignature);
}

function renderField(label: string, value: string): string {
  return `
    <div>
      <p class="smc-field-label">${escapeHtmlForPrintUnsafeContext(label)}</p>
      <p class="smc-field-value">${escapeHtmlForPrintUnsafeContext(value)}</p>
    </div>
  `;
}

function dashIfEmpty(value: string | null | undefined): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : "—";
}

function renderMembershipTermsSectionHtml(): string {
  const itemsHtml = MEMBERSHIP_TERMS_ITEMS.map(
    (item) => `<li>${escapeHtmlForPrintUnsafeContext(item)}</li>`,
  ).join("");

  return `
    <section class="smc-terms">
      <h2 class="smc-terms-title">${escapeHtmlForPrintUnsafeContext(MEMBERSHIP_TERMS_TITLE)}</h2>
      <ol class="smc-terms-list">${itemsHtml}</ol>
      <p class="smc-terms-footer">${escapeHtmlForPrintUnsafeContext(MEMBERSHIP_TERMS_FOOTER)}</p>
    </section>
  `;
}

function renderSignatureDateRow(label: string): string {
  return `
    <div class="smc-signature-row smc-signature-row--date">
      <p class="smc-signature-date-line">
        <span class="smc-signature-label">${escapeHtmlForPrintUnsafeContext(label)}</span>
        <span class="smc-signature-date-placeholder">${escapeHtmlForPrintUnsafeContext(SIGNATURE_DATE_PLACEHOLDER)}</span>
      </p>
    </div>
  `;
}

function renderSignatureRow(
  label: string,
  value: string | null,
  variant: "filled" | "blank" | "sign" = "filled",
): string {
  const valueClass =
    variant === "sign"
      ? "smc-signature-value smc-signature-value--sign"
      : variant === "blank"
        ? "smc-signature-value smc-signature-value--blank"
        : "smc-signature-value";

  const displayValue =
    value != null && value.trim()
      ? escapeHtmlForPrintUnsafeContext(value)
      : "&nbsp;";

  return `
    <div class="smc-signature-row">
      <p class="smc-signature-label">${escapeHtmlForPrintUnsafeContext(label)}</p>
      <p class="${valueClass}">${displayValue}</p>
    </div>
  `;
}

function renderMembershipSignaturesSectionHtml(params: {
  studioSignatureDataUrl?: string;
}): string {
  const studioSignBlock = params.studioSignatureDataUrl
    ? `
        <div class="smc-signature-row smc-signature-row--studio-sign">
          <img src="${params.studioSignatureDataUrl}" alt="" class="smc-studio-signature-img" />
        </div>
      `
    : renderSignatureRow("", null, "sign");

  return `
    <section class="smc-signatures">
      <h2 class="smc-signatures-title">ການຢືນຢັນ ແລະ ລາຍເຊັນ</h2>
      <p class="smc-signatures-intro">
        ຂ້າພະເຈົ້າໄດ້ອ່ານ ແລະ ເຂົ້າໃຈເງື່ອນໄຂ ແລະ ກົດລະບຽບຂ້າງເທິງຄົບຖ້ວນແລ້ວ
        ຈຶ່ງລົງລາຍເຊັນເພື່ອຢືນຢັນການສະມັກສະມາຊິກ.
      </p>
      <div class="smc-signatures-grid">
        <div class="smc-signature-block">
          <p class="smc-signature-party">ລາຍເຊັນຜູ້ສະໝັກ</p>
          ${renderSignatureRow("", null, "sign")}
          ${renderSignatureDateRow("ວັນທີ")}
        </div>
        <div class="smc-signature-block">
          <p class="smc-signature-party">Fanglao Studio</p>
          ${studioSignBlock}
        </div>
      </div>
    </section>
  `;
}

/** ເປີດຫນ້າຕ່າງພິມ A4 — ໃບຢືນຢັນການສະມັກສະມາຊິກ (ບໍ່ແມ່ນໃບເກັບເງິນ). */
export async function printStudentMembershipConfirmationA4(
  params: PrintStudentMembershipConfirmationParams,
): Promise<void> {
  const [logoDataUrl, studioSignatureDataUrl, fontFaceCss] = await Promise.all([
    loadLogoDataUrl(),
    loadStudioSignatureDataUrl(),
    loadNotoSansLaoPrintFontFaceCss(),
  ]);
  const logoBlock = logoDataUrl
    ? `<img src="${logoDataUrl}" alt="" class="smc-logo" />`
    : "";

  const origin = window.location.origin;
  const profileUrl = `${origin}/public/student/${encodeURIComponent(params.memberId)}`;
  const qrDataUrl = await QRCode.toDataURL(profileUrl, {
    width: 176,
    margin: 1,
  });

  const brandAddressLo = escapeHtmlForPrintUnsafeContext(
    config.brandAddressLo ?? config.brandAddress ?? "",
  );
  const printedAt = escapeHtmlForPrintUnsafeContext(formatDateTime(new Date()));
  const memberId = escapeHtmlForPrintUnsafeContext(params.memberId);

  const genderLabel =
    params.gender != null ? GENDER_LABELS[params.gender] : "—";

  const bodyHtml = `
    <div class="smc-actions">
      <button type="button" class="primary" onclick="window.print()">ພິມ / ບັນທຶກເປັນ PDF</button>
      <button type="button" onclick="window.close()">ປິດ</button>
    </div>
    <div class="smc-page">
      <header class="smc-header">
        <div class="smc-brand-block">
          ${logoBlock}
        </div>
        <div class="smc-doc-meta">
          <p>${brandAddressLo}</p>
          <p>ວັນທີພິມ: ${printedAt}</p>
        </div>
      </header>

      <h1 class="smc-title">ໃບຢືນຢັນການສະມັກສະມາຊິກ</h1>
      <p class="smc-subtitle">Membership Registration Confirmation</p>

      <div class="smc-top-row">
        <div class="smc-member-id-box">
          <p class="smc-member-id-label">ເລກທີ່ສະມາຊິກ</p>
          <p class="smc-member-id-value">${memberId}</p>
        </div>
        <section class="smc-profile">
          <p class="smc-profile-title">ເບິ່ງ profile (ສະແກນ QR)</p>
          <img src="${qrDataUrl}" alt="QR" class="smc-profile-qr" />
        </section>
      </div>

      <div class="smc-grid">
        ${renderField("ຊື່-ນາມສະກຸນ", params.name)}
        ${renderField("ວັນທີລົງທະບຽນ", formatDate(params.registeredAt))}
        ${renderField("ເບີໂທ", dashIfEmpty(params.phoneNumber))}
        ${renderField("ອີເມວ", dashIfEmpty(params.email))}
        ${renderField(
          "ວັນເດືອນປີເກີດ",
          params.dateOfBirth ? formatDate(params.dateOfBirth) : "—",
        )}
        ${renderField("ເພດ", genderLabel)}
        ${renderField("ກຸ່ມ", dashIfEmpty(params.groupName))}
      </div>

      ${renderMembershipTermsSectionHtml()}

      ${renderMembershipSignaturesSectionHtml({
        studioSignatureDataUrl,
      })}
    </div>
  `;

  const printWindow = window.open("", "_blank");
  if (!printWindow) return;

  const docTitle = `ໃບຢືນຢັນສະມາຊິກ — ${params.memberId}`;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html lang="lo">
      <head>
        <meta charset="utf-8" />
        <title>${escapeHtmlForPrintUnsafeContext(docTitle)}</title>
        <style>${fontFaceCss}${STUDENT_MEMBERSHIP_CONFIRMATION_PRINT_STYLES_A4}</style>
      </head>
      <body>${bodyHtml}</body>
    </html>
  `);
  printWindow.document.close();
}
